<template>
    <div class="image-text-block" :class="{ 'full-width': isFullWidth }">
      <div class="content-wrapper1">
        <a :href="url" target="_blank" v-if="url != ''">
          <BaseImage 
            :src="imageUrl" 
            :alt="alt" 
            class="background-image"
            :style="backgroundImageStyle"
          />
          <div class="text-content">
            <h3><span>{{ title }}</span></h3>
            <p>{{ content }}</p>
            <p v-if="content2">{{ content2 }}</p>
            <p v-if="content3">{{ content3 }}</p>
          </div>
        </a>
        <div v-else>
          <BaseImage 
          :src="imageUrl" 
          :alt="alt" 
          class="background-image"
          :style="backgroundImageStyle"
        />
        <div class="text-content">
          <h3><span>{{ title }}</span></h3>
          <p>{{ content }}</p>
          <p v-if="content2">{{ content2 }}</p>
          <p v-if="content3">{{ content3 }}</p>
        </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BaseImage from '@/components/common/BaseImage.vue'
  export default {
    components: {
    BaseImage
  },
    props: {
      imageUrl: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      },
      content2: {
        type: String,
        required: false
      },
      content3: {
        type: String,
        required: false
      },
      isFullWidth: {
        type: Boolean,
        default: false
      },
      url: {
        type: String,
        required: true
      }
    },
    computed: {
      backgroundImageStyle() {
        return {
          aspectRatio: this.isFullWidth ? '734 / 234' : '364 / 233'
        };
      }
    }
  }
  </script>
  
  <style scoped>
  .image-text-block {
    width: 45%;
    height: 100%;
    position: relative;
    box-shadow: 2px 5px 8px #999;
  }

  .image-text-block.full-width {
    width: 100%;
  }
  .background-image{
    transition: transform 0.5s ease;
    transform-origin: center;
    transform: scale(1);
  }
  .background-image:hover{
    transition: transform 0.5s ease;
    transform-origin: center;
    transform: scale(1.1);
  }
  
  .content-wrapper1 :deep(.base-image) {
    transition: transform 0.5s ease;
    transform-origin: center;
    transform: scale(1);
  } 

  .full-width .text-content{
    width: 20%;
  }
  
  .text-content {
    position: absolute;
    left: 20px;
    color: #fff;
    z-index: 2;
    width: 40%;
    padding: 0 20px;
  }
  
  .text-content h3 {
    font-size:  clamp(1.5rem, 2vw, 2rem);
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    /* position: absolute;
    bottom: 26px; */
    line-height: 1.2em;
    margin-bottom: 6px;
  }
  .text-content h3 span{
    display: inline-block;
  }
  
  .text-content p {
    font-size: clamp(0.8rem, 1vw, 1rem);
    line-height: 1.6;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  }
  .text-content h3 span::after {
        content: '';
        display: block;
        width: 0;
        /* 初始宽度为0 */
        height: 1.5px;
        /* 边框高度 */
        background: white;
        /* 边框颜色 */
        transition: width 0.5s ease;
        /* 平滑过渡效果 */
       
    }
        /* 鼠标悬停时的动画效果 */
        
    .image-text-block:hover .text-content h3 span::after {
        width: 100%;
    }
   
  
  @media screen and (max-width: 768px) {
    .image-text-block:hover .text-content h3 span::after {
    width: 0;
    /* 在移动端保持宽度为0，隐藏效果 */
  }
    .image-text-block {
      width: 100%;
      height: 50vh;
      margin-bottom: 5px!important;
      box-shadow: 1px 2px 3px #999;
    }
    .text-content{
      width: 100%;
        padding: 0;
        bottom:20px;
        left: 0;
        right: 0;
        padding: 50px 20px 16px;
        bottom: 0;
        background: #00000050;
    }
    .text-content h3 {
      font-size:clamp(1.3rem, 2vw, 1.5rem);
      margin-top: -30px;
    }
  

}
  </style>